import React, { useEffect } from "react";

export const useOutsideClick = (ref: any, callback: any) => {
  const handleOutsideClick = (e: any) => {
    if (!ref?.current?.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);

    return () => {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  });
};
